import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.disconnect();
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const finalRaw = this.element.dataset.decimalAnimationFinalValue;
        const finalNumber = parseFloat(finalRaw);
        if (isNaN(finalNumber)) return;

        this.animateDecimalCount(this.element, finalNumber, 2000); // 2s -- same as animationin css file
      }
    });
  }

  animateDecimalCount(el, finalNumber, duration) {
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const t = Math.min(elapsed / duration, 1);

      // Apply easing
      const easedProgress = this.easeOutCubicBezier(t);
      const currentVal = (easedProgress * finalNumber).toFixed(2); // decimal 2 digits

      const [intPart, decimalPart] = currentVal.split(".");
      const padded = `${intPart.padStart(2, "0")}.${decimalPart}`; // add 0 in the front -- eaxmple 7.10 -> 07.10

      el.textContent = padded;

      // do it again, if it not 100%
      if (t < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

  // Easing function that mimics cubic-bezier(0.25, 1, 0.9, 1) -- same as animationin css file
  easeOutCubicBezier(t) {
    return 1 - Math.pow(1 - t, 3);
  }
}
